const DEV_ONBOARDING_HOSTNAME = 'dev-onboarding.revers.io';
const ONBOARDING_PREVIEW_HOSTNAME_SUFFIXES = [
  `.preview.${DEV_ONBOARDING_HOSTNAME}`,
  `.preview-front.${DEV_ONBOARDING_HOSTNAME}`,
];

export function getOnboardingHostname(): string {
  const { hostname } = window.location;
  const isOnboardingPreview = ONBOARDING_PREVIEW_HOSTNAME_SUFFIXES.some(
    (suffix) => hostname.endsWith(suffix),
  );

  return isOnboardingPreview ? DEV_ONBOARDING_HOSTNAME : hostname;
}
